<div class="page-header" [hidden]="digests?.length === 0">
  <h1 class="page-header__title">Trends</h1>
  <div class="page-header__on-right" *ngIf="showEmailDigestSubscriptionBtn">
    <a
      class="btn btn--primary float-md-right"
      href="/users/{{ user.id }}/edit#tab-notifications"
      target="_self"
    >
      <i class="glyphicon glyphicon-envelope glyphicon--valign-baseline"></i>
      Subscribe to digest emails
    </a>
  </div>
</div>
<div class="alerts-container">
  <ab-alerts-common></ab-alerts-common>
</div>
<div class="empty-state text-center col-xs-12" *ngIf="digests?.length === 0">
  <div class="empty-state-header lp-gradient-bkg">
    <div class="empty-state-header__content">
      <h2 class="mt-4">
        There are no generated trends for your project yet. Your first trends
        will be visible next week.
      </h2>
      <p class="mt-4">
        Here you will be able to compare your project's key Error, Deploy, and
        Performance metrics on a week-by-week basis.
      </p>
    </div>
  </div>
  <div class="container">
    <ng-container *ngIf="projectIsMissingAnyData">
      <div class="col-md-12">
        <h3 class="mt-4">Please ensure that your project sends:</h3>
      </div>
      <div class="col-md-12">
        <ul class="list-distributed list-unstyled text-center mt-4">
          <li *ngIf="missingErrorData">
            <h4>
              <span class="glyphicon glyphicon-bug"></span>
              Errors
            </h4>
            <p>Please visit the dashboard for more info:</p>
            <a class="btn btn--primary btn--default" uiSref="project-errors">
              Errors Dashboard
            </a>
          </li>
          <li *ngIf="missingDeployData">
            <h4>
              <span class="glyphicon glyphicon-flash"></span>
              Deploys
            </h4>
            <p>Please visit the dashboard for more info:</p>
            <a class="btn btn--secondary btn--default" uiSref="project-deploys">
              Deploys Dashboard
            </a>
          </li>
          <li *ngIf="missingPerformanceData">
            <h4>
              <span class="glyphicon glyphicon-ab-gauge"></span>
              Performance data
            </h4>
            <p>Please visit the dashboard for more info:</p>
            <a
              class="btn btn--success btn--default"
              uiSref="project-performance"
            >
              Performance Dashboard
            </a>
          </li>
        </ul>
      </div>
    </ng-container>
  </div>
</div>

<ng-container *ngIf="featureDisabled !== undefined">
  <div class="flex-grow-1 content-mask-container">
    <div class="content-mask" *ngIf="featureDisabled">
      <div class="content-mask__content">
        <p class="content-mask__text">
          This dashboard is showing sample data. Enable the Trends Dashboard to
          compare your project's key Error, Deploy, and Performance metrics on a
          week-by-week basis.
        </p>
        <button
          class="btn btn--upgrade"
          (click)="openUpgradeModal($event)"
          data-feature="trends_dashboard"
          type="button"
        >
          Enable the Trends Dashboard
        </button>
      </div>
    </div>

    <div class="col-xs-12 trends-dashboard" *ngIf="digests?.length > 0">
      <div class="trends-dashboard__side" *ngIf="digests">
        <ul class="interval-list list-unstyled">
          <li class="interval-list__item">
            <span class="title-small">Mon</span>
            <span class="title-small">Sun</span>
          </li>
          <li
            class="interval-list__item interval-list__item--hover"
            *ngFor="let digest of digests; trackBy: trackBy"
            [ngClass]="{
              'interval-list__item--active': digest === selectedDigest
            }"
            uiSref="project-trends"
            [uiParams]="{ digestId: digest.id }"
          >
            <span>{{ digest.interval.start }}</span>
            <span>-</span>
            <span>{{ digest.interval.end }}</span>
          </li>
        </ul>
      </div>
      <div class="trends-dashboard__main" *ngIf="selectedDigest">
        <h3>
          {{ selectedDigest.interval.start }} to
          {{ selectedDigest.interval.end }}
        </h3>
        <p class="text-small">{{ selectedDigest.full_interval }}</p>
        <ab-digest-stats
          [project]="project"
          [digestId]="selectedDigest.id"
          [featureDisabled]="featureDisabled"
          [missingErrorData]="missingErrorData"
          [missingDeployData]="missingDeployData"
          [missingPerformanceData]="missingPerformanceData"
        ></ab-digest-stats>
      </div>
    </div>
  </div>
</ng-container>
